// extracted by mini-css-extract-plugin
export default {"textEditor":"TextEditor_textEditor__VYziF","textEditorContent":"TextEditor_textEditorContent__jKJmQ"};